import { render, staticRenderFns } from "./TicketCard.vue?vue&type=template&id=7a4f524a&scoped=true&"
import script from "./TicketCard.vue?vue&type=script&lang=js&"
export * from "./TicketCard.vue?vue&type=script&lang=js&"
import style0 from "./TicketCard.vue?vue&type=style&index=0&id=7a4f524a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4f524a",
  null
  
)

export default component.exports